import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-button-form',
  standalone: true,
  imports: [CommonModule, NgIcon],
  templateUrl: './button-form.html',
  styleUrl: './button-form.css',
})
export class ButtonForm {
  @Input() label = '';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: 'primary' | 'secondary' | 'outline' | 'ghost' | 'social' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() fullWidth = false;
  @Input() loading = false;
  @Input() disabled = false;
  @Input() iconName = '';

  @Output() onClick = new EventEmitter<MouseEvent>();

  variantClasses = {
    primary: 'text-white bg-brand-500 hover:bg-brand-600 shadow-lg shadow-brand-500/30 rounded-2xl active:scale-95',
    secondary: 'text-white bg-slate-900 hover:bg-slate-800 dark:bg-slate-800 dark:hover:bg-slate-700 dark:border dark:border-slate-700 shadow-xl shadow-slate-900/10 rounded-2xl active:scale-95',
    outline: 'text-slate-900 dark:text-slate-100 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-2xl active:scale-95',
    ghost: 'text-slate-600 dark:text-slate-300 hover:text-brand-600 dark:hover:text-brand-400 hover:bg-brand-50 dark:hover:bg-slate-800 rounded-xl',
    social: 'text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 shadow-sm rounded-xl py-3'
  } as const;

  sizeClasses = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base'
  } as const;
}
